import { steps } from "./steps";

export default function determineStep(page) {
  return steps.findIndex((x) => x.indexOf(page) > -1);
}
